// @flow
import {Machine} from 'xstate';
import {assign} from 'xstate';
import BlueflagAuth from 'bfu-auth-client/src/login/data/BlueflagAuth.js';

const ROUTE_TRANSITIONS = {
    GOTO_confirm: 'confirm',
    GOTO_forgotPassword: 'forgotPassword',
    GOTO_signin: 'signin',
    GOTO_signup: 'signup',
    GOTO_auth0Landing: 'auth0Landing'
};

const signinStates = {
    initial: 'default',
    states: {
        default: {},
        afterSignupConfirm: {
            meta: {
                status: {
                    message: 'Account successfully confirmed. Please login.',
                    modifier: 'positive'
                }
            }
        },
        afterChoosePassword: {
            meta: {
                status: {
                    message: 'Password successfully set. Please login.',
                    modifier: 'positive'
                }
            }
        }
    }
};

const signupConfirmStatusStates = {
    initial: 'default',
    states: {
        default: {},
        errorResending: {
            meta: {
                status: {
                    message: 'Error resending verification code, please try again',
                    modifier: 'negative'
                }
            }
        }
    }
};

export default Machine(
    {
        id: 'login',
        initial: 'init',
        context: {
            username: undefined,
            verificationResponse: undefined
        },
        states: {
            init: {
                on: ROUTE_TRANSITIONS
            },
            auth0Landing: {
                onEntry: 'setRouteToAuth0Landing',
                on: {
                    ...ROUTE_TRANSITIONS
                    // what the hell?
                }
            },
            signin: {
                onEntry: 'setRouteToSignin',
                on: {
                    ...ROUTE_TRANSITIONS,
                    // This shouldn't happen now that the lambda is automatically signing people up
                    // Keeping just in case it fails.
                    SIGNUP_CONFIRM_RESEND: {
                        target: 'signupConfirmResend',
                        actions: 'setUsername'
                    }
                },
                ...signinStates
            },
            forgotPassword: {
                onEntry: 'setRouteToForgotPassword',
                on: {
                    ...ROUTE_TRANSITIONS,
                    FORGOT_PASSWORD_REQUEST_SUCCESS: {
                        target: 'choosePassword',
                        actions: 'setUsername'
                    }
                }
            },
            choosePassword: {
                on: {
                    ...ROUTE_TRANSITIONS,
                    FORGOT_PASSWORD_CONFIRM_SUCCESS: {
                        target: 'signin.afterChoosePassword',
                        actions: 'setUsername'
                    }
                }
            },
            signup: {
                onEntry: 'setRouteToSignup',
                on: {
                    ...ROUTE_TRANSITIONS,
                    SIGNUP_SUCCESS: {
                        target: 'signin.afterSignupConfirm',
                        actions: 'setUsername'
                    }
                }
            },
            confirm: {
                onEntry: 'setRouteToConfirm',
                on: {
                    ...ROUTE_TRANSITIONS,
                    SIGNUP_CONFIRM_SUCCESS: 'signin.afterSignupConfirm',
                    SIGNUP_CONFIRM_RESEND: 'signupConfirmResend'
                },
                ...signupConfirmStatusStates
            },
            signupConfirm: {
                on: {
                    ...ROUTE_TRANSITIONS,
                    SIGNUP_CONFIRM_SUCCESS: 'signin.afterSignupConfirm',
                    SIGNUP_CONFIRM_RESEND: 'signupConfirmResend'
                },
                ...signupConfirmStatusStates
            },
            signupConfirmResend: {
                invoke: {
                    src: 'signUpConfirmResend',
                    onDone: {
                        target: 'signupConfirm',
                        actions: assign({
                            verificationResponse: (context, event) => event.data
                        })
                    },
                    onError: {
                        target: 'signupConfirm.errorResending'
                    }
                }
            }
        }
    },
    {
        actions: {
            setUsername: assign({
                username: (context, {username}) => username
            })
        },
        services: {
            signUpConfirmResend: (context, {username}) => {
                return BlueflagAuth().signUpConfirmResend(username);
            }
        }
    }
);
